/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import clsx from 'clsx'
import { useAuth } from '../../../../setup/context/AppContext'
import { useLayout } from '../../core'
import { Header } from './Header'
import { Topbar } from './Topbar'
import { useIntl } from 'react-intl'

export function HeaderWrapper() {
  const { classes } = useLayout()
  const {
    currentStep,
    handleCurrentStep,
    requestSqlVersion,
    setRequestSqlVersion,
    applySqlUpdates,
    setApplySqlUpdates,
    applingScriptName,
    applingSystem,
    requestXmlVersion,
    setRequestXmlVersion,
    applyXmlUpdates,
    setApplyXmlUpdates
  } = useAuth();

  const intl = useIntl()

  const handleBack = () => {
    let nextStep = currentStep - 1;
    handleCurrentStep(nextStep);
  }

  const handleRequestSQLVersion = () => {
    setRequestSqlVersion(true);
  }

  const handleRequestXMLVersion = () => {
    setRequestXmlVersion(true);
  }

  const handleUpdateApplySql = () => {
    setApplySqlUpdates(true);
  }

  const handleUpdateApplyXml = () => {
    setApplyXmlUpdates(true);
  }

  const disabled = requestSqlVersion || requestXmlVersion || applySqlUpdates || applyXmlUpdates

  return (
    <div
      id='kt_header'
      className='header align-items-stretch'
      style={{ left: 0 }}
    >
      <div
        className={clsx(
          classes.headerContainer.join(' '),
          'd-flex align-items-stretch justify-content-between'
        )}
      >
        {
          currentStep === 2 &&
          <div className='d-flex justify-content-center align-items-center'>
            <button
              className='btn btn-sm btn-flex btn-primary btn-active-primary fw-bolder'
              style={{ height: '40px' }}
              onClick={handleBack}
            >
              Search
            </button>
          </div>
        }
        {/* begin::Wrapper */}
        <div className='d-flex align-items-center justify-content-between flex-lg-grow-1'>
          <div className='d-flex align-items-stretch' id='kt_header_nav'>
            <Header />
          </div>
          {
            applingSystem &&
            <h1 className='d-flex align-items-center text-dark fw-bolder my-1 fs-3'>
              Appling {applingScriptName ? `(${applingScriptName})` : ""} -&nbsp;{applingSystem?.description}
            </h1>
          }

          <div className='d-flex justify-content-between'>
            {
              currentStep === 2 &&
              <div className='d-flex justify-content-center align-items-center me-2'>
                <button
                  className='btn btn-sm btn-flex btn-primary btn-active-primary fw-bolder'
                  onClick={handleRequestXMLVersion}
                  disabled={disabled}
                >
                  {!requestXmlVersion ?
                    <span className='indicator-label'>
                      {intl.formatMessage({ id: 'SEARCH.MENU.REQUEST.XML' })}
                    </span>
                    :
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      {
                        intl.formatMessage({ id: 'MENU.PLEASE.WAIT' })
                      }
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  }
                </button>
              </div>
            }
            {
              currentStep === 2 &&
              <div className='d-flex justify-content-center align-items-center me-2'>
                <button
                  className='btn btn-sm btn-flex btn-primary btn-active-primary fw-bolder'
                  onClick={handleUpdateApplyXml}
                  disabled={disabled}
                >
                  {!applyXmlUpdates ?
                    <span className='indicator-label'>
                      {intl.formatMessage({ id: 'SEARCH.MENU.APPLY.XML' })}
                    </span>
                    :
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      {
                        intl.formatMessage({ id: 'MENU.PLEASE.WAIT' })
                      }
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  }
                </button>
              </div>
            }
            {
              currentStep === 2 &&
              <div className='d-flex justify-content-center align-items-center me-2'>
                <button
                  className='btn btn-sm btn-flex btn-primary btn-active-primary fw-bolder'
                  onClick={handleRequestSQLVersion}
                  disabled={disabled}
                >
                  {!requestSqlVersion ?
                    <span className='indicator-label'>
                      {intl.formatMessage({ id: 'SEARCH.MENU.REQUEST.SQL' })}
                    </span>
                    :
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      {
                        intl.formatMessage({ id: 'MENU.PLEASE.WAIT' })
                      }
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  }
                </button>
              </div>
            }
            {
              currentStep === 2 &&
              <div className='d-flex justify-content-center align-items-center'>
                <button
                  className='btn btn-sm btn-flex btn-primary btn-active-primary fw-bolder'
                  onClick={handleUpdateApplySql}
                  disabled={disabled}
                >
                  {!applySqlUpdates ?
                    <span className='indicator-label'>
                      {intl.formatMessage({ id: 'SEARCH.MENU.APPLY.SQL' })}
                    </span>
                    :
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      {
                        intl.formatMessage({ id: 'MENU.PLEASE.WAIT' })
                      }
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  }
                </button>
              </div>
            }

            <div className='d-flex align-items-center flex-shrink-0'>
              <Topbar />
            </div>
          </div>
        </div>
        {/* end::Wrapper */}
      </div>
    </div>
  )
}
